<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <v-dialog
      v-model="credential_dialog"
      max-width="800"
      persistent
    >
      <v-card>
        <v-layout wrap v-show="colaborador_credencial.front" v-if="is_admin()">
            <v-flex text-md-right text-sm-right text-xs-right>
              <v-btn flat icon color="blue darken-1"
                @click="print_credential_front_back(colaborador_credencial.front, colaborador_credencial.back)"
              >
                <v-icon>badge</v-icon>
              </v-btn>
            <v-divider class="mt-0"/>
          </v-flex>
          </v-layout>
        <v-layout wrap>
          <v-flex xs6 sm6 md6 v-show="colaborador_credencial.front">
            <img :src="this.credencial_image(colaborador_credencial.front)" style="width: 50%"/>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat="flat"
                   v-on:click="print_credential(colaborador_credencial.front)">
              Frente
            </v-btn>
          </v-flex>
          <v-flex xs6 sm6 md6 v-show="colaborador_credencial.back">
            <img :src="this.credencial_image(colaborador_credencial.back)" style="width: 50%"/>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat="flat"
                   v-on:click="print_credential(colaborador_credencial.back)">
              Reverso
            </v-btn>
          </v-flex>
        </v-layout>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat="flat"
                 @click="close_credential_dialog">
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-container grid-list-md fluid>
      <v-alert
        :value="alert"
        dismissible
        :type="alertType"
      >
        {{ alertMessage }}
      </v-alert>
      <v-layout wrap>
        <v-flex xs12 sm6 md11>
          <v-card-title>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="presearch"
              append-icon="search"
              label="Buscar"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
        </v-flex>
        <v-flex xs12 sm6 md1 class="pt-4">
          <v-btn color="primary" dark @click.prevent="agregar_colaborador()"
                 v-show="add_btn === true" :disabled="!add_btn">
            Agregar
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <v-data-table
      :headers="headers"
      :items="colaboradores"
      :pagination.sync="pagination"
      :total-items="totalItems"
      :loading="is_loading"
      :rows-per-page-items="[5,10,25,50]"
      disable-initial-sort
    >
      <template v-slot:items="props">
        <tr>
          <td class="text-xs-left">{{ props.item.numero_empleado }}</td>
          <td class="text-xs-left">{{ props.item.credencial }}</td>
          <td class="text-xs-left">{{ props.item.primer_nombre }}</td>
          <td class="text-xs-left">{{ props.item.primer_apellido }}</td>
          <td class="text-xs-left">{{ props.item.segundo_apellido }}</td>
          <td class="text-xs-left">{{ props.item.empresa }}</td>
          <td class="text-xs-left">{{ props.item.gerencia }}</td>
          <td class="text-xs-left" v-if="props.item.status == 'capacitacion'">
            EN CAPACITACIÓN
          </td>
          <td class="text-xs-left" v-else-if="props.item.status !== null">
            {{ props.item.status.toUpperCase() }}
          </td>
          <td class="text-xs-left" v-else>
            {{ props.item.status }}
          </td>
          <td class="text-xs-left">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon @click.prevent="mostrar_colaborador(props.item.colaborador_id)"
                        v-show="view_btn === true" :disabled="!view_btn"
                        v-on="on" class="mr-2" small>
                  visibility
                </v-icon>
              </template>
              <span>Detalles del Colaborador</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon @click.prevent="editar_colaborador(props.item.colaborador_id)"
                        v-show="edit_btn === true" :disabled="!edit_btn"
                        v-on="on" class="mr-2" small>
                  edit
                </v-icon>
              </template>
              <span>Editar Colaborador</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon @click.prevent="generate_credential(props.item.colaborador_id)"
                        v-if="props.item.status == 'activo'"
                        v-show="print_btn === true" :disabled="!print_btn"
                        v-on="on" class="mr-2" small>
                  print
                </v-icon>
                <v-icon @click.prevent="generate_credential(props.item.colaborador_id)"
                        v-else-if="props.item.status == 'capacitacion'"
                        v-show="print_btn === true" :disabled="!print_btn"
                        v-on="on" class="mr-2" small>
                  print
                </v-icon>
                <v-icon @click.prevent="generate_credential(props.item.colaborador_id)"
                        v-else
                        v-show="print_btn === true" :disabled="true"
                        v-on="on" class="mr-2" small>
                  print
                </v-icon>
              </template>
              <span>Credencial</span>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { getJWTData } from '../common/jwt.service';

export default {
  data: () => ({
    colaborador_credencial: {},
    totalItems: 0,
    colaboradores: [],
    pagination: {},
    timer: '',
    search: null,
    presearch: null,
    searchTimer: null,
    infodialog: false,
    headers: [
      { text: 'Núm. Empleado', value: 'numero_empleado', sortable: true },
      { text: 'Credencial', value: 'credencial', sortable: true },
      { text: 'Nombre(s)', value: 'primer_nombre', sortable: true },
      { text: 'Primer Apellido', value: 'primer_apellido', sortable: true },
      { text: 'Segundo Apellido', value: 'segundo_apellido', sortable: true },
      { text: 'Empresa', value: 'empresa', sortable: true },
      { text: 'Gerencia', value: 'gerencia', sortable: true },
      { text: 'Estatus', value: 'status', sortable: true },
      { text: 'Acciones', value: 'acciones', sortable: false },
    ],
    motivo_disabled: true,
    editcolaborador: false,
    valid: true,
    dialog: false,
    btnuploadfiles: false,
    btnaddfiles: true,
    btnsubmitfiles: true,
    baseImg: 'data:image/png;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==',
    constraints: { video: { width: 1280, height: 720 } },
    credential_dialog: false,
    view_btn: false,
    edit_btn: false,
    print_btn: false,
    add_btn: false,
  }),
  computed: {
    is_loading() {
      return this.$store.getters['listadoColaboradores/is_loading'];
    },
    colaborador_submited() {
      return this.$store.getters['listadoColaboradores/colaborador_submited'];
    },
    alertType() {
      return this.$store.getters['listadoColaboradores/alertContainerType'];
    },
    alertMessage() {
      return this.$store.getters['listadoColaboradores/alertContainerMessage'];
    },
    alert() {
      return this.$store.getters['listadoColaboradores/alertContainer'];
    },
    alertDialogType() {
      return this.$store.getters['listadoColaboradores/alertDialogType'];
    },
    alertDialogMessage() {
      return this.$store.getters['listadoColaboradores/alertDialogMessage'];
    },
    alertDialog() {
      return this.$store.getters['listadoColaboradores/alertDialog'];
    },
    colaborador_processing() {
      return this.$store.getters['listadoColaboradores/colaborador_processing'];
    },
    colaborador_info() {
      return this.$store.getters['listadoColaboradores/collaborator_info'];
    },
  },
  watch: {
    pagination: {
      handler() {
        if (this.search !== '' && this.search != null) {
          this.getDataFromApi()
            .then((data) => {
              this.colaboradores = data.colaboradores;
              this.totalItems = data.total;
            });
        }
      },
      deep: true,
    },
    search(val) {
      if (val === '') {
        this.colaboradores = [];
        this.totalItems = 0;
      } else {
        this.getDataFromApi()
          .then((data) => {
            this.colaboradores = data.colaboradores;
            this.totalItems = data.total;
          });
      }
    },
    presearch() {
      this.cancelSearchTimer();
      this.searchTimer = setInterval(this.updateSearch, 1000);
    },
  },
  methods: {
    agregar_colaborador() {
      this.$router.push({ name: 'agregar_colaborador' });
    },
    editar_colaborador(colaboradorId) {
      this.$router.push({ name: 'captura_colaboradores', params: { id: colaboradorId } });
    },
    mostrar_colaborador(colaboradorId) {
      this.$router.push({ name: 'detalles_colaborador', params: { id: colaboradorId } });
    },
    getDataFromApi() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        const { sortBy, page, rowsPerPage } = this.pagination;
        let { descending } = this.pagination;
        if (descending === null) {
          descending = false;
        }
        const formdata = {
          page,
          per_page: rowsPerPage,
          search: this.search,
          order_by: sortBy,
          descending,
        };
        this.$store.dispatch('listadoColaboradores/fetchColaboradores', formdata)
          .then((data) => {
            this.loading = false;
            const { colaboradores, total } = data;
            this.$store.commit('listadoColaboradores/fetchedColaboradores');
            resolve({
              colaboradores,
              total,
            });
          });
      });
    },
    credencial_image(val) {
      let encoded = '';
      const extension = 'png';
      if (typeof val !== 'undefined') {
        encoded = val;
      } else {
        encoded = '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';
      }
      return `data:image/${extension};base64,${encoded}`;
    },
    colaborador_image() {
      let encoded = '';
      let extension = '';
      if (typeof this.colaborador_info.rostros !== 'undefined' && this.colaborador_info.rostros.length > 0) {
        encoded = this.colaborador_info.rostros[this.colaborador_info.rostros.length - 1].image;
        const check = encoded.charAt(0);
        if (check === '/') {
          extension = 'jpg';
        } else if (check === '/') {
          extension = 'png';
        } else extension = 'tiff';
      } else {
        extension = 'jpeg';
        encoded = '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';
      }
      return `data:image/${extension};base64,${encoded}`;
    },
    updateSearch() {
      if (this.presearch !== this.search) {
        this.search = this.presearch;
      }
    },
    cancelAutoUpdate() {
      clearInterval(this.timer);
    },
    cancelSearchTimer() {
      if (this.searchTimer !== null) {
        clearInterval(this.searchTimer);
      }
    },
    fetchCollaboratorsList() {
      if (!this.$store.getters['listadoColaboradores/is_loading']) {
        this.$store.dispatch('listadoColaboradores/clearColaboradoresAction');
        this.$store.dispatch('listadoColaboradores/fetchColaboradores');
      }
    },
    generate_credential(collaborator) {
      const formData = {
        colaborador_id: collaborator,
      };
      this.$store.dispatch('listadoColaboradores/generateCredential', formData).then((data) => {
        this.colaborador_credencial = data;
      });
      this.credential_dialog = true;
    },
    print_credential_front_back(front, back) {
      const base = 'data:image/png;base64, ';
      const srcimgfront = base.concat(front);
      const srcimgback = base.concat(back);
      const mywindow = window.open('', 'PRINT');
      const isChrome = Boolean(mywindow.chrome);
      mywindow.document.write('<html><body>');
      mywindow.document.write(`<img src="${srcimgfront}" width="195" style="border-style: dashed none dashed dashed;border-width: 2px;border-color: #000;padding: 5px;">`);
      mywindow.document.write(`<img src="${srcimgback}" width="195" style="border: 2px dashed #000; padding: 5px;">`);
      mywindow.document.write('</body></html>');
      if (isChrome) {
        setTimeout(() => { // wait until all resources loaded
          mywindow.document.close(); // necessary for IE >= 10
          mywindow.focus(); // necessary for IE >= 10
          mywindow.print(); // change window to winPrint
          mywindow.close(); // change window to winPrint
        }, 250);
      } else {
        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10
        mywindow.print();
        mywindow.close();
      }

      return true;
    },
    print_credential(val) {
      const base = 'data:image/png;base64, ';
      const srcimg = base.concat(val);
      const mywindow = window.open('', 'PRINT');
      const isChrome = Boolean(mywindow.chrome);
      mywindow.document.write('<html><body>');
      mywindow.document.write(`<img src="${srcimg}" width="159" height="249">`);
      mywindow.document.write('</body></html>');
      if (isChrome) {
        setTimeout(() => { // wait until all resources loaded
          mywindow.document.close(); // necessary for IE >= 10
          mywindow.focus(); // necessary for IE >= 10
          mywindow.print(); // change window to winPrint
          mywindow.close(); // change window to winPrint
        }, 250);
      } else {
        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10
        mywindow.print();
        mywindow.close();
      }

      return true;
    },
    close_credential_dialog() {
      this.colaborador_credencial = {};
      this.credential_dialog = false;
    },
    is_admin() {
      if (['admin'].includes(this.user_login_role)) {
        return true;
      }
      return false;
    },
  },
  created() {
    this.user_login_role = getJWTData().user_claims.role;
    if (['jefe_monitoristas', 'monitoristas', 'censo', 'admin'].includes(this.user_login_role)) {
      if (['censo', 'admin'].includes(this.user_login_role)) {
        this.view_btn = true;
        this.edit_btn = true;
        this.print_btn = true;
        this.add_btn = true;
      } else if (['jefe_monitoristas', 'monitoristas'].includes(this.user_login_role)) {
        this.view_btn = true;
      }
    }
  },
  beforeDestroy() {
    this.cancelSearchTimer();
  },
};
</script>
<style type="text/css">
</style>
